import { render, staticRenderFns } from "./WTitle.vue?vue&type=template&id=bd83ac58&scoped=true&"
import script from "./WTitle.vue?vue&type=script&lang=js&"
export * from "./WTitle.vue?vue&type=script&lang=js&"
import style0 from "./WTitle.vue?vue&type=style&index=0&id=bd83ac58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd83ac58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
